import { render, staticRenderFns } from "./coOrder.vue?vue&type=template&id=26b000bc&scoped=true&"
import script from "./coOrder.vue?vue&type=script&lang=js&"
export * from "./coOrder.vue?vue&type=script&lang=js&"
import style0 from "./coOrder.vue?vue&type=style&index=0&id=26b000bc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26b000bc",
  null
  
)

export default component.exports